import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TaxonomyCodeIcon from "../../../assets/images/svg-icons-material-io/link_FILL0_wght400_GRAD0_opsz48.svg";
import MonitorIcon from "../../../assets/images/svg-icons-material-io/screenshot_monitor_FILL0_wght400_GRAD0_opsz48.svg";
import BulkUploadTemplate from "../../../assets/images/OrgbulkUploadimg.JPG";
import CallAPI from "../../../services/apiCalls";
import useUserStore from "../../../utils/storeApp";
import $ from "jquery";
import fileDownload from "js-file-download";
import CreateFilenameModal from "../../upload-status/CreateFilenameModal";
import { UploadType } from "../../../utils/enums";

const obj = {
  VendorId: 0,
  OrganizationId: 0,
  OrganizationName: "",
  UserSubmitFile: "",
};
const UploadOrgForm = () => {
  const { userToken, sharedObject, SetSharedObject, userRole, userSession } =
    useUserStore((state) => ({
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
      sharedObject: state.sharedObject,
      userRole: state.userRole,
      userSession: state.userSession,
    }));

  const [processing, SetProcessing] = useState(false);
  const [submitFlag, SetSubmitFlag] = useState(false);
  const [errFlag, SetErrFlag] = useState(false);
  const [answers, setAnswers] = useState(obj);
  const [orgObj, SetOrgObj] = useState([]);
  const [custObject, SetCustObject] = useState([]);

  const vend = () => {
    const temp = [];
    let flag = false;
    let id = 0;
    for (let el of sharedObject.vendorsObj) {
      el.show = true;
      temp.push(el);
      if (
        userRole !== "SES ADMINISTRATOR" &&
        userRole !== "SYSTEMADMINISTRATOR" &&
        el.id === parseInt(userSession.vendor_id)
      ) {
        let vl = el.id;
        setAnswer("VendorId", vl);
        id = vl;
        flag = true;
      }
    }
    SetCustObject(temp);
    if (flag && id !== 0) {
      CustomerIdSet(id);
    }
  };
  useEffect(() => {
    if (
      userRole !== "SES ADMINISTRATOR" &&
      userRole !== "SYSTEMADMINISTRATOR"
    ) {
      const temp = [];
      for (let el of sharedObject.getOrgsObj) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObj(temp);
    } else {
      vend();
    }
    SetSharedObject("specialties", {});
    SetSubmitFlag(false);
  }, []);

  const setAnswer = async (questionId, answer, chck) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  const CustomerIdSet = async (el) => {
    if (el === "") {
      SetOrgObj([]);
      return;
    }
    SetProcessing(true);
    let call = "/users/GetOrgsByCustID?vendorID=" + parseInt(el);
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      const temp = [];
      for (let el of res.data.data) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObj(temp);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  const filterVendors = (val) => {
    const tmp = [];
    if (val.length > 1) {
      custObject?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      custObject?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetCustObject(tmp);
  };
  const filterOrganiations = (val) => {
    const tmp = [];
    if (val.length > 1) {
      orgObj?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      orgObj?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetOrgObj(tmp);
  };

  const downTemplate = async (url) => {
    SetProcessing(true);
    const res = await CallAPI(url, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let fileName = "OrganizationUploadTemplate.csv";
      fileDownload(res.data, fileName);
      SetProcessing(false);
    }
  };

  const initiateUpload = () => {
    const fileInput = document.querySelector('input[type="file"]');
    const file = fileInput.files[0];
    let o = {
      UploadType: UploadType.AddOrganizations,
      UploadFile: file,
      OrganizationId: answers.OrganizationId,
    };
    SetSharedObject("UploadStausObj", o);
  };

  const triggerValidation = (el) => {
    var regex = new RegExp("(.*?).(csv)$");
    if (!regex.test(el.target.value.toLowerCase())) {
      SetErrFlag(true);
    } else {
      setAnswer("UserSubmitFile", el);
      SetErrFlag(false);
    }
  };
  const getDomain = (url) => {
    url = url.replace(/(https?:\/\/)?(www.)?/i, "");
    if (url.indexOf("/") !== -1) {
      return url.split("/")[0];
    }
    return url;
  };
  const openImg = () => {
    let url = getDomain(window.location.hostname);
    if (url === "localhost") {
      window.open(BulkUploadTemplate);
    } else {
      window.open(BulkUploadTemplate);
    }
  };

  const [loadingText, setLoadingText] = useState("Signing you in...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Signing you in...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  return (
    <div className="UploadOrgForm">
    {/* Visually hidden heading for form landmarking */}
    <h2 id="upload-org-form-title" className="sr-only">
        Upload Organizations Form
      </h2>
      <form className="sp-pad1" aria-labelledby="upload-org-form-title">
        {/*Left Panel*/}
        <div className="left-panel-s1">
          {userRole !== "SES ADMINISTRATOR" &&
          userRole !== "SYSTEMADMINISTRATOR" ? null : (
            <div className="field-wrapper">
              <label htmlFor="customerSearch">Customer</label>
              <span className="filter-container dg-clr">
                <input
                  className="form-control filter-sm"
                  type="search"
                  placeholder="Filter"
                  aria-label="Filter Customers"
                  onChange={(el) => {
                    filterVendors(el.target.value);
                  }}
                />
              </span>
              <label htmlFor="VendorId" className="sr-only">Customer Select Dropdown</label>
              <select
                className="form-control"
                size="5"
                id="VendorId"
                name="VendorId"
                onChange={(el) => {
                  CustomerIdSet(el.target.value);
                  setAnswer("VendorId", parseInt(el.target.value));
                }}
                value={answers?.VendorId}
              >
                <option value={0}>Select Customer</option>
                {custObject?.map((el) => {
                  if (el.show)
                    return (
                      <option key={el.id} value={el.id}>
                        {el.name}
                      </option>
                    );
                })}
              </select>
              {submitFlag && answers?.VendorId === 0 ? (
                <div className="alert alert-danger" role="alert">Customer is required.</div>
              ) : null}
            </div>
          )}
          {/*Organization - show only for org admins*/}
          <div className="field-wrapper">
            <label htmlFor="OrganizationId">Parent Organization</label>
            <span className="filter-container dg-clr">
              <input
                className="form-control filter-sm"
                type="search"
                placeholder="Filter"
                aria-label="Filter Organizations"
                onChange={(el) => filterOrganiations(el.target.value)}
              />
            </span>
            {orgObj.length > 0 ? (
              <select
                className="form-control"
                size="4"
                name="OrganizationId"
                id="OrganizationId"
                onChange={(el) => {
                  setAnswer("OrganizationId", parseInt(el.target.value));
                }}
                value={answers?.OrganizationId}
              >
                <option value={0}>Select Organization</option>
                {orgObj?.map((el) => {
                  if (el.show)
                    return (
                      <option key={el.id} value={`${el.id}`}>
                        {el.name}
                      </option>
                    );
                })}
              </select>
            ) : (
              <div className="watermark-wrapper">No Results</div>
            )}
            {answers?.OrganizationId === 0 && submitFlag ? (
              <div className="alert alert-danger" role="alert">
                Organization is required.
              </div>
            ) : null}
          </div>
          {/*Select CSV File*/}
          <div className="field-wrapper">
            <label htmlFor="UserSubmitFile">Select CSV file</label>
            <div className="form-group">
              <input
                type="file"
                className="form-control-file  cblu-clr "
                id="UserSubmitFile"
                aria-describedby="csv-instructions"
                onChange={(el) => {
                  triggerValidation(el);
                }}
                //value={answers?.UserSubmitFile}
              />
              {answers?.UserSubmitFile === "" && submitFlag ? (
                <div className="alert alert-danger" role="alert">CSV file is required.</div>
              ) : null}
            </div>
            {errFlag ? (
              <div className="alert alert-danger" role="alert">
                The file you are trying to upload is not a CSV file. Please try
                again using a proper file type with a .csv file extension. You
                can also download our template and view our sample below.
              </div>
            ) : null}
            <aside className="filelist-items" id="csv-instructions">
              The MS Excel spreadsheet must be saved as a CSV format that
              contains a .csv extension and rename the file if you intend to
              upload it again.
            </aside>
          </div>
          {/*Processing Spinner*/}
          
        {processing ? (
            <div 
                className="loader-container" 
                role="status" 
                aria-live="polite" 
                aria-atomic="true"
                aria-labelledby="loader-id"
            >
                <div className="spinner" aria-hidden="true"></div>
                <div className="loading-text" id="loader-id">{loadingText}</div>
            </div>
        ) : null}
            
          {/*Upload Action*/}
          <div className="button-register-container">
            <button
              type="button"
              className="btn btn-success"
              onClick={(e) => {
                SetSubmitFlag(true);
                if (
                  answers?.OrganizationId !== 0 &&
                  answers?.UserSubmitFile !== ""
                ) {
                  initiateUpload();
                  $("#createFilenameModal").modal("show");
                }
              }}
            >
              Upload
            </button>
            <Link
              className="btn btn-outline-secondary spacer-margin2 "
              to="/Organizations"
            >
              Cancel
            </Link>
          </div>

          {/*Templates*/}
          <div className="box-template">
            <button
              onClick={(el) => {
                downTemplate(
                  "/organization/DownloadCsvTemplate?csv=OrganizationUploadTemplate"
                );
                el.preventDefault();
              }}
              className="btn btn-primary box-containers box-sentmsg"
              tabIndex={0}
              aria-label="Download CSV File Template"
            >
              <div className="box-icon">
                <i className="bi bi-download" aria-hidden="true"></i>
              </div>
              <div className="box-bottom">
                <div className="title">CSV File Template</div>
              </div>
            </button>
            <a
              href="https://www.nucc.org/index.php?option=com_content&view=article&id=107&Itemid=132"
              target="_blank"
              className="btn btn-primary box-containers box-status"
              rel="noreferrer"
              aria-label="NUCC Taxonomy Codes (opens in new tab)"
            >
              <div className="box-icon">
                <img
                  src={TaxonomyCodeIcon}
                  className="filter-white"
                  aria-hidden="true"
                  alt=""
                />
              </div>
              <div className="box-bottom">
                <div className="title">NUCC Taxonomy Codes</div>
              </div>
            </a>
            <button
              onClick={openImg}
              target="_blank"
              className="btn btn-primary box-containers box-reports"
              alt=""
              tabIndex={0}
              aria-label="Sample CSV Template Screenshot"
            >
              <div className="box-icon">
                <img
                  src={MonitorIcon}
                  className="filter-white"
                  alt=""
                  aria-hidden="true"
                />
              </div>
              <div className="box-bottom">
                <div className="title">
                  Sample <br />
                  CSV File Screenshots
                </div>
              </div>
            </button>
          </div>
        </div>

        {/*Right Panel*/}
        <div className="right-panel-s1">
          {/*Requirement Rules*/}
          <div className="field-wrapper label-hd-divider">Requirements</div>
          <div className="field-wrapper">
            <div className="text-reg spacer-margin7">
              The following list of items are required and must be included in
              your file.
            </div>
            <ul className="filelist-items">
              <li>
                <span className="ft-wt blk-clr">Organization Name</span>
              </li>
              <li>
                <span className="ft-wt blk-clr">External ID:</span> Organization
                ID
                <ul>
                  <li>Must be unique</li>
                  <li>Can only have letters, numbers, hyphens, or periods</li>
                </ul>
              </li>
              <li>
                <span className="ft-wt blk-clr">
                  Organization Type (OrgKind):
                </span>
                <ul className="split-col">
                  <li>Health_System</li>
                  <li>LTCP</li>
                  <li>HCO</li>
                  <li>HCP</li>
                  <li>Pharmacy</li>
                  <li>Department</li>
                  <li>Non_HealthcareProvider</li>
                  <li>Practice</li>
                  <li>HIE</li>
                  <li>Payer</li>
                  <li>Lab</li>
                  <li>Hospital</li>
                  <li>Supplier</li>
                </ul>
              </li>
              <li>
                <span className="ft-wt blk-clr">Address 1:</span> 100 character
                limit
              </li>
              <li>
                <span className="ft-wt blk-clr">City:</span> 100 character limit
              </li>
              <li>
                <span className="ft-wt blk-clr">State:</span> State Abbreviation
                - 2 character limit - Uppercase Only
              </li>
              <li>
                <span className="ft-wt blk-clr">Zip Code:</span> 5 character
                limit
              </li>
              <li>
                <span className="ft-wt blk-clr">Phone Number:</span> Use
                xxxxxxxxxx format
              </li>
            </ul>
          </div>

          {/*Optional Rules*/}
          <div className="field-wrapper label-hd-divider">Optional</div>
          <div className="field-wrapper">
            <div className="text-reg spacer-margin7">
              The following list of items are your options to include in your
              file.
            </div>
            <ul className="filelist-items">
              <li>
                <span className="ft-wt blk-clr">OrgKind Description:</span>
                <ul className="split-col">
                  <li>Health System</li>
                  <li>Long Term Care Provider</li>
                  <li>Health Care Organization</li>
                  <li>Health Care Provider</li>
                  <li>Pharmacy</li>
                  <li>Department/Functional Group</li>
                  <li>Non-Healthcare Provider</li>
                  <li>Practice</li>
                  <li>Health Information Exchange</li>
                  <li>Payer</li>
                  <li>Laboratory</li>
                  <li>Hospital</li>
                  <li>Supplier</li>
                </ul>
              </li>
              <li>
                <span className="ft-wt blk-clr">Keywords:</span> Provide a
                collection of important but yet easy to search words
              </li>
              <li>
                <span className="ft-wt blk-clr">NUCC Taxonomy:</span> Input the
                code found in the current version of the National Uniform Claim
                Committee Health Care Provider Taxonomy Code Set.
              </li>
              <li>
                <span className="ft-wt blk-clr">
                  NPI (National Provider ID):
                </span>
                Must be a 10 digit number (Use xxxxxxxxxx format)
              </li>
              <li>
                <span className="ft-wt blk-clr">Address 2:</span> 100 character
                limit
              </li>
              <li>
                <span className="ft-wt blk-clr">Fax Number:</span> Use
                xxxxxxxxxx format
              </li>
            </ul>
          </div>
        </div>
      </form>
      <CreateFilenameModal />
    </div>
  );
};

export default UploadOrgForm;
